"use client";

import { SANDBOX_SESSION_EXPIRING_SOON_MS, SANDBOX_SESSION_POLL_INTERVAL_MS } from "@/constants/sandboxSession.constants";
import { SANDBOX_SESSION_INVALID_CODE } from "@/constants/sandboxErrorCodes.constants";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { useNow } from "@/hooks/useNow";
import { api } from "@/lib/api";
import { useSandboxSessionStore } from "@/stores/sandboxSessionStore";
import { xErrorCodeOf } from "@/utils/trpcError.utils";
import { useSandboxSession } from "../useSandboxSession";
import { Button } from "./Button";
import { Callout } from "./Callout";
import { SandboxAssertionEditor } from "./SandboxAssertionEditor";
export function SandboxBar() {
  const t = useClientTranslations("sandbox");
  const sandboxSessionId = useSandboxSessionStore(s => s.sandboxSessionId);
  const storeExpiresAt = useSandboxSessionStore(s => s.expiresAt);
  const assertions = useSandboxSessionStore(s => s.assertions);
  const setAssertions = useSandboxSessionStore(s => s.setAssertions);
  const {
    leave
  } = useSandboxSession();
  const sessionQuery = api.sandbox.getSession.useQuery(undefined, {
    enabled: Boolean(sandboxSessionId),
    refetchInterval: SANDBOX_SESSION_POLL_INTERVAL_MS
  });
  const now = useNow();
  const expiresAt = sessionQuery.data?.expiresAt ? Date.parse(sessionQuery.data.expiresAt) : storeExpiresAt;
  const remainingMs = expiresAt !== null ? expiresAt - now.getTime() : null;
  const isExpired = remainingMs !== null && remainingMs <= 0 || xErrorCodeOf(sessionQuery.error) === SANDBOX_SESSION_INVALID_CODE;
  const isExpiringSoon = !isExpired && remainingMs !== null && remainingMs <= SANDBOX_SESSION_EXPIRING_SOON_MS;
  return <Callout tone={isExpired || isExpiringSoon ? "warn" : "yellow"} className="mx-4 mt-3 rounded-field" action={<div className="flex items-center gap-2">
                    <SandboxAssertionEditor assertions={assertions} onSetAssertions={setAssertions} />
                    <Button variant="ghost" size="sm" onClick={leave}>
                        {t("bar.leaveButton")}
                    </Button>
                </div>} data-sentry-element="Callout" data-sentry-component="SandboxBar" data-sentry-source-file="SandboxBar.tsx">
            {isExpired ? t("bar.expiredMessage") : isExpiringSoon && remainingMs !== null ? t("bar.expiringMessage", {
      minutes: Math.max(1, Math.ceil(remainingMs / 60_000))
    }) : t("bar.message")}
        </Callout>;
}